module.exports = __webpack_public_path__ + "img/Pista_2406.995c1285.png";